import { render, staticRenderFns } from "./FdrWrapper.vue?vue&type=template&id=edc8aefa&scoped=true&"
import script from "./FdrWrapper.vue?vue&type=script&lang=js&"
export * from "./FdrWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FdrWrapper.vue?vue&type=style&index=0&id=edc8aefa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc8aefa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
